/**
 * Data minimization for public payloads (P-038). Public errors, observability
 * events, and logs must never carry secrets or unnecessary PII. These helpers
 * scrub the values the SDK forwards to host callbacks, events, and reporters.
 */
const REDACTED = "[redacted]";
const SENSITIVE_PATTERNS = [
    // Email addresses.
    /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi,
    // Stripe-style secrets / keys / payment intents.
    /\b(?:sk|pk|rk)_(?:live|test)_[a-z0-9]+/gi,
    /\b(?:pi|seti|cs|pm|ch)_[a-z0-9]+_secret_[a-z0-9]+/gi,
    /client_secret["':=\s]+[a-z0-9_-]+/gi,
    // Bearer / access tokens.
    /\bBearer\s+[a-z0-9._-]+/gi,
];
// Card-like number runs (13-19 digits, optionally space/dash separated). A
// millisecond timestamp is also 13 digits, so a run is only masked when it
// passes the Luhn check every card number satisfies.
const CARD_LIKE_PATTERN = /\b(?:\d[ -]?){13,19}\b/g;
function isLuhnValid(digits) {
    let sum = 0;
    let double = false;
    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = Number(digits[i]);
        if (double) {
            digit *= 2;
            if (digit > 9)
                digit -= 9;
        }
        sum += digit;
        double = !double;
    }
    return sum % 10 === 0;
}
/** Mask sensitive substrings inside a string. */
export function redactString(value) {
    let result = value;
    for (const pattern of SENSITIVE_PATTERNS) {
        result = result.replace(pattern, REDACTED);
    }
    return result.replace(CARD_LIKE_PATTERN, (run) => isLuhnValid(run.replace(/[ -]/g, "")) ? REDACTED : run);
}
/** Recursively redact string values inside a JSON-ish structure. */
export function redactValue(value) {
    if (typeof value === "string")
        return redactString(value);
    if (Array.isArray(value))
        return value.map(redactValue);
    if (value && typeof value === "object") {
        const out = {};
        for (const [key, item] of Object.entries(value)) {
            out[key] = redactValue(item);
        }
        return out;
    }
    return value;
}
